// src/ReferralHandler.js
import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie'; // Import js-cookie
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

const REFERRAL_COOKIE_NAME = 'referralCode'; // Define a constant for the cookie name
const COOKIE_EXPIRATION_DAYS = 7; // Set how long the cookie should last (e.g., 7 days)

function ReferralHandler() {
    const { referralCode } = useParams(); // Get the code from the URL parameter
    const navigate = useNavigate();

    useEffect(() => {
        if (referralCode) {
            console.log(`Referral code found: ${referralCode}`);
            // Set the cookie
            Cookies.set(REFERRAL_COOKIE_NAME, referralCode, {
                expires: COOKIE_EXPIRATION_DAYS,
                path: '/', // Make cookie available across the entire site
                // Optional: Add 'secure: true' if only serving over HTTPS
                // Optional: Add 'sameSite: 'Lax' or 'Strict' for security
            });
            console.log(`Cookie "${REFERRAL_COOKIE_NAME}" set.`);
        }
        // Redirect to the homepage after setting the cookie (or attempting to)
        navigate('/', { replace: true }); // Use replace to avoid adding the referral URL to history
    }, [referralCode, navigate]);

    // Display a loading/processing message while the effect runs
    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
            <CircularProgress />
            <Typography sx={{ ml: 2 }}>Applying referral code...</Typography>
        </Box>
    );
}

export default ReferralHandler;